
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><g clip-path='url(#clip0_17:17244)'><path d='M10.23 1.75C9.64001 1.16 8.69001 1.16 8.11001 1.75L1.75001 8.11C1.16001 8.7 1.16001 9.65 1.75001 10.23L13.77 22.25C14.36 22.84 15.31 22.84 15.89 22.25L22.25 15.89C22.84 15.3 22.84 14.35 22.25 13.77L10.23 1.75ZM14.12 20.48L3.52001 9.88C3.13001 9.49 3.13001 8.86 3.52001 8.47L8.47001 3.52C8.86001 3.13 9.49001 3.13 9.88001 3.52L20.49 14.13C20.88 14.52 20.88 15.15 20.49 15.54L15.54 20.49C15.15 20.87 14.51 20.87 14.12 20.48ZM17.61 1.4C16.04 0.569999 14.06 -0.0300012 11.81 0.0199988C11.63 0.0199988 11.55 0.239999 11.67 0.369999L15.15 3.85L16.48 2.52C19.57 3.98 21.82 6.89 22.37 10.38C22.43 10.79 22.81 11.07 23.23 11C23.64 10.94 23.92 10.55 23.85 10.14C23.25 6.34 20.89 3.14 17.61 1.4ZM8.85001 20.16L7.52001 21.49C4.43001 20.03 2.18001 17.12 1.63001 13.63C1.57001 13.22 1.19001 12.94 0.770013 13.01C0.360013 13.07 0.0800133 13.46 0.150013 13.87C0.750013 17.68 3.11001 20.88 6.39001 22.62C7.96001 23.45 9.94001 24.05 12.19 24C12.37 24 12.45 23.78 12.33 23.65L8.85001 20.16Z' fill='#323232'/></g><defs><clipPath id='clip0_17:17244'><rect width='24' height='24' fill='white'/></clipPath></defs></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-screen-rotation`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconScreenRotation

    ```js
    <b-new-b-icon-screen-rotation />
    ```
</docs>


